import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取购物车推荐数据列表（#94）
 */
export function getCardrecommendList() {
  return request("".concat(BASE_URL) + "/shopCartRecommend/list", METHOD.GET);
}

/** 添加购物车推荐商品数据（#96）
 * @param {Object} data
 */
export function addCardrecommend(data) {
  return request("".concat(BASE_URL) + "/shopCartRecommend", METHOD.POST, data);
}

/** 更新购物车推荐商品状态信息（#97）
 * @param {Object} data
 */
export function updateCardrecommendState(data) {
  return request("".concat(BASE_URL) + "/shopCartRecommend/status", METHOD.PUT, data);
}

/** 更新购物车推荐列表顺序（#95）
 * @param {Object} data
 */
export function updateCardrecommendSort(data) {
  return request("".concat(BASE_URL) + "/shopCartRecommend/sort", METHOD.PUT, data);
}

/** 删除购物车推荐商品数据（#98）
 * @param {Object} data
 */
export function deleteCardrecommend(id) {
  return request("".concat(BASE_URL) + "/shopCartRecommend/" + id, METHOD.DELETE);
}

/**
 * 根据商品编号获取商品规格列表数据（#9899）
 */
export function getSpecDetailList(no, onlyShelf) {
  return request("".concat(BASE_URL) + "/product/specDetail/list/" + no + '?onlyShelf=' + onlyShelf, METHOD.GET);
}